import React from 'react'
import { useRouter } from 'next/router'
import TermsEn from './terms.en.mdx'
import Terms from './terms.mdx'
import MdPage from '@components/app/md-page'

const TermsView = () => {
  const router = useRouter()
  return (
    <div className="container-sm pt-5">
      <MdPage>
        {
          router.locale === 'ja' ? <Terms /> : <TermsEn />
        }
      </MdPage>
    </div>
  )
}

export default TermsView
